module.exports = __webpack_public_path__ + "img/paris-hilton-2025-2-s.40f5b87a.webp";